var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,33.75,42)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,16.893999099731445,8.536999702453613)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,175,111)",
    fillOpacity: 1,
    d: " M0.6179999709129333,8.28600025177002 C0.6179999709129333,8.28600025177002 -0.6179999709129333,8.28600025177002 -0.6179999709129333,8.28600025177002 C-4.830999851226807,8.28600025177002 -8.246999740600586,4.872000217437744 -8.246999740600586,0.6579999923706055 C-8.246999740600586,0.6579999923706055 -8.246999740600586,-0.6579999923706055 -8.246999740600586,-0.6579999923706055 C-8.246999740600586,-4.870999813079834 -4.830999851226807,-8.28600025177002 -0.6179999709129333,-8.28600025177002 C-0.6179999709129333,-8.28600025177002 0.6179999709129333,-8.28600025177002 0.6179999709129333,-8.28600025177002 C4.830999851226807,-8.28600025177002 8.246999740600586,-4.870999813079834 8.246999740600586,-0.6579999923706055 C8.246999740600586,-0.6579999923706055 8.246999740600586,0.6579999923706055 8.246999740600586,0.6579999923706055 C8.246999740600586,4.872000217437744 4.830999851226807,8.28600025177002 0.6179999709129333,8.28600025177002z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,33.75,42)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,11.303999900817871,14.166000366210938)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    stroke: "rgb(245,175,111)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M0.31200000643730164,6.303999900817871 C0.31200000643730164,6.303999900817871 -0.3109999895095825,6.303999900817871 -0.3109999895095825,6.303999900817871 C-3.621000051498413,6.303999900817871 -6.304999828338623,3.621999979019165 -6.304999828338623,0.31200000643730164 C-6.304999828338623,0.31200000643730164 -6.304999828338623,-0.31200000643730164 -6.304999828338623,-0.31200000643730164 C-6.304999828338623,-3.621999979019165 -3.621000051498413,-6.303999900817871 -0.3109999895095825,-6.303999900817871 C-0.3109999895095825,-6.303999900817871 0.31200000643730164,-6.303999900817871 0.31200000643730164,-6.303999900817871 C3.621999979019165,-6.303999900817871 6.304999828338623,-3.621999979019165 6.304999828338623,-0.31200000643730164 C6.304999828338623,-0.31200000643730164 6.304999828338623,0.31200000643730164 6.304999828338623,0.31200000643730164 C6.304999828338623,3.621999979019165 3.621999979019165,6.303999900817871 0.31200000643730164,6.303999900817871z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet);
export default __webpack_public_path__ + "static/media/set.20157b76e9f31fff8886bcb1c4356a7c.svg";
export { ForwardRef as ReactComponent };